import { useTranslation } from 'react-i18next';

import { AddressAutocomplete } from '../../../../components/design-system/common/AddressAutocomplete';
import { TradePlace, useTradeApi } from '../../../../common/hooks/use-trade-api.hook';

/**
 * Where the vendor sells from: the address field with suggestions from the
 * French address register (towns, postcodes, streets), through the API.
 * Picking one hands back its position, so it is saved as a point.
 */
export const TradeOriginInput = ({
    id,
    value,
    onValueChange,
    onPick,
    onSubmit,
    disabled,
}: {
    id?: string;
    value: string;
    onValueChange: (text: string) => void;
    onPick: (place: TradePlace) => void;
    onSubmit?: () => void;
    disabled?: boolean;
}) => {
    const { t } = useTranslation();
    const api = useTradeApi();

    return (
        <AddressAutocomplete
            id={id}
            value={value}
            onValueChange={onValueChange}
            onPick={onPick}
            onSubmit={onSubmit}
            search={(q, init) => api.searchPlaces(q, init)}
            disabled={disabled}
            placeholder={t('TRADE.SETTINGS.ORIGIN_PLACEHOLDER', 'A town, a postcode or an address')}
            labels={{
                list: t('TRADE.ADDRESS.LIST', 'Address suggestions'),
                searching: t('TRADE.ADDRESS.SEARCHING', 'Searching…'),
                noMatch: t('TRADE.ADDRESS.NO_MATCH', 'No match. Try a postcode or a town.'),
                unavailable: t('TRADE.ADDRESS.UNAVAILABLE', 'Suggestions are unavailable right now. You can still type the address and save.'),
                postcodeHint: t('TRADE.ADDRESS.POSTCODE_HINT', 'Type all five digits of the postcode.'),
            }}
            attribution={t('TRADE.ADDRESS.ATTRIBUTION', 'Addresses: Base Adresse Nationale')}
            data-testid="trade-origin-input"
        />
    );
};

export default TradeOriginInput;
